import { render, staticRenderFns } from "./AppAside.vue?vue&type=template&id=f24e2ac6&scoped=true"
import script from "./AppAside.vue?vue&type=script&lang=js"
export * from "./AppAside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24e2ac6",
  null
  
)

export default component.exports